:host {
  display: block;
  position: relative;
}

.br-tooltip {
  .content {
    display: none;
    border-radius: 4px;
    box-shadow: var(--surface-offset-xl) var(--surface-offset-xl) var(--surface-offset-xl) rgb(0 0 0 / 16%);
    color: var(--pure-0);
    font-size: var(--font-size-scale-down-01);
    font-weight: var(--font-weight-regular);
    width: max-content;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    z-index: 4;

    &.small {
      padding: var(--spacing-scale-base) var(--spacing-scale-base);
    }

    &.medium {
      padding: var(--spacing-scale-baseh) var(--spacing-scale-baseh);
    }

    &.large {
      padding: var(--spacing-scale-2x) var(--spacing-scale-2x);
    }

    &.is-visible {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &.popover {
      br-button {
        align-self: flex-start;
        margin-left: var(--spacing-scale-half);
      }
    }

    &:focus-visible {
      outline: var(--focus) var(--focus-style) var(--focus-width);
      outline-offset: var(--focus-offset);
    }
  }

  .arrow {
    position: absolute;
    width: 8px;
    height: 8px;
    transform: rotate(45deg);
  }

  .content,
  .arrow {
    &.info {
      background-color: var(--blue-warm-vivid-60);

      br-button::part(button) {
        color: var(--pure-0);
      }

      br-button::part(button):hover {
        background: linear-gradient(rgb(var(--pure-0-rgb), var(--hover)), rgb(var(--pure-0-rgb), var(--hover)));
      }
    }

    &.warning {
      background-color: var(--yellow-vivid-20);
      color: var(--gray-80);

      br-button::part(button) {
        color: var(--gray-80);
      }

      br-button::part(button):hover {
        background: linear-gradient(rgb(var(--gray-80-rgb), var(--hover)), rgb(var(--gray-80-rgb), var(--hover)));
      }
    }

    &.error {
      background-color: var(--red-vivid-50);

      br-button::part(button) {
        color: var(--pure-0);
      }

      br-button::part(button):hover {
        background: linear-gradient(rgb(var(--pure-0-rgb), var(--hover)), rgb(var(--pure-0-rgb), var(--hover)));
      }
    }

    &.success {
      background-color: var(--green-cool-vivid-50);

      br-button::part(button) {
        color: var(--pure-0);
      }

      br-button::part(button):hover {
        background: linear-gradient(rgb(var(--pure-0-rgb), var(--hover)), rgb(var(--pure-0-rgb), var(--hover)));
      }
    }
  }
}
